const machine_txt = {
    type: "VA-600D-33YD-7/301",
    name: "Automatic Bottom Hem Ribbing Machine",
    description: [
        "Application",
        "Hoodies, coat rib-knitted bottom hemmer",
        "Functional Characteristics",
        "Automatic double rectifying device+ front rectifying device, fabric edge automatic positioning is more stable and sensitive.",
        "Switch the size with one key.",
        "Broken thread detection device.",
        "Automatic trimming.",
        "Discarded ends collection device.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/18/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/18/machine_other/1.png",
        "/assets/machine/18/machine_other/2.png",
    ]
}
export default {machine_txt}